import { Injectable, inject } from '@angular/core';
import { AuthSessionService } from '@app/core/services/auth-session/auth-session.service';
import { DeviceDetectService } from '@app/core/services/device-detect/device-detect.service';
import { NavDataService } from '@app/core/services/nav-data/nav-data.service';

import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomepageService {
  private authSessionService: AuthSessionService = inject(AuthSessionService);
  constructor(
    private navDataService: NavDataService,
    private deviceDetect: DeviceDetectService
  ) {}

  resolve(): Observable<any> | Promise<any> | any {
    if (this.deviceDetect.isNativeDevice) {
      if (this.authSessionService.isLogged) {
        this.navDataService.navigate('/account');
        return false;
      } else {
        this.navDataService.navigate(environment.mainPage.cordova);
        return false;
      }
    }

    return true;
  }
}
